<template>
  <main class="wrapper-content w-100">
    <b-row utters id="dashboar-home" v-if="!enableDashboardBuilder">
      <b-col cols="12" class="wrapper-content">
        <b-row class="wrapper-title-page">
          <b-col cols="10" class="d-flex  align-items-center">
            <h4 class="page-title">{{ title }}</h4>
          </b-col>
          <b-col cols="2" class="d-flex justify-content-end align-items-center">
            <LmBtnUpdateContent />
          </b-col>
        </b-row>
        <b-row>
          <component
            v-for="(componentData, index) in dashItems"
            :key="index"
            :is="componentData.component"
            v-bind="componentData.prop"
            :chart-data="componentData.chartData"
            :chart-option="componentData.chartOption"
            :class="{'lm-loader': componentData.component.startsWith('LmChart') ? loading : false }"
            :showHeaderTable="true"
            :hideHeadersBelowRows="true"
          />
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-4 h-100" v-if="enableDashboardBuilder">
      <div class="wrapper-content">
        <LmButton
          class="d-flex justify-content-end sticky-top"
          style="top: 2em; z-index: 1;"
          :value="!isOnCustomizationMode ? 'Editar Dashboard' : 'Guardar cambios'"
          :buttonClass="!isOnCustomizationMode ? 'btn-primary' : 'btn-success'"
          :icon="isOnCustomizationMode ? 'save' : 'wrench'"
          @click="onCustomizationModeChange"
        />

        <LmSvgIcon
          v-if="!myWidgets.length && !isOnCustomizationMode"
          style="height: calc(100% - 35px - 1.5rem); padding-bottom: calc((35px + 1.5rem) * 2);"
          wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column"
          width="18em"
          icon="LmDashboardIcon"
          text="Crea tu propio Dashboard"
        />

        <draggable
          class="row"
          animation="150"
          handle=".handle"
          v-model="myWidgets"
          @start="drag=true"
          @end="drag=false"
          :sort="isOnCustomizationMode"
        >
          <LmWidget
            :class="[isOnCustomizationMode ? 'handle' : '']"
            v-for="(widget, index) of myWidgets"
            :key="index"
            :component="widget.component"
            :widget="widget.properties"
            :isOnCustomizationMode="isOnCustomizationMode"
            :customization="widget.customization"
            @onWidgetRemove="onWidgetRemove(index)"
            @onWidgetCustomizationChange="onWidgetCustomizationChange($event, index)"
          />
        <b-col cols="3" v-if="isOnCustomizationMode">
          <div class="bg-light p-4 shadow">
            <h4>Nuevo widget</h4>
            <p>Agrega un nuevo widget al dashboard</p>
            <LmSelect
              label="Widgets"
              :options="widgetsOptions"
              v-model="widgetId"
            />
            <LmButton
              :disabled="widgetId === ''"
              type="button"
              size="sm"
              buttonClass="btn-primary"
              :value="$t('add')"
              @click="onAddWidget"
            />
          </div>
        </b-col>
        </draggable>
      </div>
    </b-row>
  </main>
</template>

<script>
// import apiSettings from '@/api/settings'
import commonsApi from '@/api/commons'
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import LmBtnUpdateContent from '@/components/LmBtnUpdateContent.vue'
import draggable from 'vuedraggable'
import LmButton from '@/components/form/elements/LmButton.vue'
import LmSelect from '@/components/form/elements/LmSelect.vue'

import LmWidget from '@/components/LmWidget'

import lmToasts from '@/mixins/lmToasts.js'

import { getWidgetCustomizationProps } from '@/helpers/LmWidgets'

export default {
  mixins: [lmToasts],
  data () {
    return {
      enableDashboardBuilder: !!process?.env?.VUE_APP_ENABLE_DASHBOARDBUILDER,
      title: '',
      isOnCustomizationMode: false,
      myDashboardId: '',
      myWidgets: [],
      widgets: [],
      widgetId: '',
      widgetsOptions: {
        disabledOption: 'Seleccione una opción',
        content: []
      }
    }
  },
  computed: {
    ...mapState('settings', ['dashItems', 'loading'])
  },
  components: {
    LmBtnUpdateContent,
    draggable,
    LmButton,
    LmSelect,
    LmWidget
  },
  methods: {
    ...mapActions('settings', ['getDashSettings']),
    async onAddWidget () {
      try {
        const newWidget = this.widgets.find(el => el._id === this.widgetId)
        if (newWidget) {
          newWidget.customization = getWidgetCustomizationProps(newWidget.component)
          newWidget.customization.size = Math.max.apply(null, newWidget?.properties?.sizes) || 12

          // Si no tiene un dashboardbuilder, crear uno, sino actualizar el existente
          if (this.myDashboardId) {
            await commonsApi.axiosPutWrapper(`/dashboardbuilder/${this.myDashboardId}/addwidget`, {
              widgets: [{
                widgetId: this.widgetId,
                customization: newWidget.customization
              }]
            })
          } else {
            const res = await commonsApi.axiosPostWrapper('/dashboardbuilder/', {
              name: 'Mi nuevo dashboard',
              widgets: [{
                widgetId: this.widgetId,
                customization: newWidget.customization
              }]
            })
            this.myDashboardId = res.data?._id
          }
          this.myWidgets.push(newWidget)
          this.lmToastSuccessMessage('Se agregó un nuevo widget en tu dashboard.', 'Se agregó exitosamente')
          this.widgetId = ''
        }
      } catch (error) {
        console.log(error)
        this.lmToastDangerMessage(error.message, 'Error')
      }
    },
    async onWidgetRemove (index) {
      try {
        const myWidgetsCopy = _.cloneDeep(this.myWidgets)
        const res = await commonsApi.axiosPutWrapper(`/dashboardbuilder/${this.myDashboardId}/removewidget`, {
          widgetId: myWidgetsCopy[index]._id
        })
        this.myWidgets.splice(index, 1)
        this.lmToastSuccessMessage(`Se eliminó ${res?.data?.name || ' el widget'} correctamente en tu dashboard.`, 'Se eliminó exitosamente')

        this.isOnCustomizationMode = false
      } catch (error) {
        console.log(error)
      }
    },
    async onWidgetCustomizationChange (event, index) {
      this.myWidgets[index].customization = Object.assign(this.myWidgets[index].customization, event)
    },
    async onCustomizationModeChange (event) {
      this.isOnCustomizationMode = !this.isOnCustomizationMode
      if (!this.isOnCustomizationMode && this.myDashboardId) {
        try {
          await commonsApi.axiosPutWrapper(`/dashboardbuilder/${this.myDashboardId}`, {
            widgets: this.myWidgets.map(mw => {
              return {
                widgetId: mw._id,
                customization: mw.customization
              }
            })
          })
          this.lmToastSuccessMessage(`Se guardaron correctamente los cambios de tu dashboard.`, 'Se guradó exitosamente')
        } catch (error) {
          console.log(error)
        }
      }
    }
  },
  async created () {
    (async () => {
      try {
        const response = await this.getDashSettings()
        if (response.hasOwnProperty('title')) {
          this.title = response.title
        } else {
          this.title = this.$t('Dashboard')
        }
      } catch (error) {
        console.log(error)
      }
    })()

    if (this.enableDashboardBuilder) {
      try {
        const widgets = await commonsApi.axiosGetWrapper('/widgets/all')
        this.widgets = widgets.data
        // Obtengo dashboard builder
        const dash = await commonsApi.axiosGetWrapper('/dashboardbuilder/mine')
        if (Object.keys(dash.data).length) {
          dash.data.widgets.forEach(el => {
            const widgetsCopy = _.cloneDeep(this.widgets)
            const widget = widgetsCopy.find(w => el.widgetId === w._id)
            if (widget) {
              widget.customization = el.customization
              this.myWidgets.push(widget)
            }
          })
          this.myDashboardId = dash.data._id
        } else {
          console.log('No hay dashboard')
        }
        // Cargo las opciones para nuevos widgets
        this.widgetsOptions.content = widgets.data.map(widget => {
          return {
            text: widget.name,
            value: widget._id
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
